module.exports = __webpack_public_path__ + "static/img/architecture.e4b995d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/open-platform/architecture.png
// module id = DUS6
// module chunks = 1